/** Mask strings that do not come from i18next */

const ourStrings = new Set<string>();

/**
 * Extracts text content from translation strings and registers them as "our strings"
 * so they won't be masked. This handles i18next's Trans component format where
 * tags like <1>, <br/>, </0> wrap translatable text segments.
 *
 * We split by walking through instead of using a regex with quantifiers to avoid
 * ReDoS vulnerabilities from catastrophic backtracking.
 */
export function unmaskString(string: string) {
  let start = 0;
  let tagStart: number;
  while ((tagStart = string.indexOf("<", start)) !== -1) {
    if (start < tagStart) {
      ourStrings.add(string.substring(start, tagStart));
    }
    const tagEnd = string.indexOf(">", tagStart);
    if (tagEnd === -1) return; // Unclosed tag, do not register malformed string
    start = tagEnd + 1;
  }
  if (start < string.length) {
    ourStrings.add(string.substring(start));
  }
}

export function mask(string: string): string {
  if (ourStrings.has(string)) return string;
  return "*".repeat(string.length);
}

export const __TEST_ONLY_INTERNALS__ = {
  ourStrings,
};
